import { i as e, t } from "./ajvresolver-Cxtdueba.js";
import { n } from "./ConfigEditorContext-CoIs6lgL.js";
import { t as r } from "./configEditor.translations-DXHXmRwX.js";
import { t as i } from "./PanelHeader-D-Qg1q2l.js";
import { t as a } from "./JsonEditor-B1GnJRBy.js";
import { t as o } from "./DeleteConfirmation-Ck6QKDDx.js";
import { n as s, t as c } from "./form-errors-Cclg0hCD.js";
import { Block as l, Link as u, useRouter as d } from "@tanstack/react-router";
import { useCallback as f, useEffect as p, useMemo as m, useRef as h, useState as g } from "react";
import { useFormContext as _, useFormState as v } from "react-hook-form";
import { Fragment as y, jsx as b, jsxs as x } from "react/jsx-runtime";
import { Button as S, Icon as C, IconButton as w, MenuPopover as T, Panel as E, StaticTooltipHost as D, Typography as O, cn as k, useDialog as A, useToast as j } from "@vintecc/components";
import { faArrowLeft as M, faBracketsCurly as N, faClose as P, faCode as F, faEllipsisVertical as I, faRouter as L, faSave as R, faSpinner as z, faTrashAlt as B, faUpload as V } from "@vintecc/pro-light-svg-icons";
import { noop as H } from "@tanstack/react-query";
//#region src/components/layout/ConfigurationActionJsonPanel.tsx
var U = ({ onClose: n, onApply: o, defaultValue: s = {}, disabled: c, externalSchemas: l }) => {
	let { t: u } = r(), { openToast: d } = j(), [f, p] = g(!0), [h, _] = g(JSON.stringify(s, null, 2)), v = m(() => l || t(), [l]);
	return /* @__PURE__ */ x(E, {
		className: "flex flex-col w-full max-w-4xl",
		children: [
			/* @__PURE__ */ b(i, {
				title: u("configEditor.json.editor", "JSON Editor"),
				icon: /* @__PURE__ */ b(C, {
					icon: N,
					className: "text-grey-400",
					size: "lg"
				}),
				onClose: n
			}),
			/* @__PURE__ */ b("div", {
				className: " w-full flex flex-col gap-4 h-full",
				children: /* @__PURE__ */ b(a, {
					disabled: c,
					onChange: _,
					value: h,
					schemas: v,
					onValidate: (e) => {
						p(e.filter((e) => !e.message.includes("deprecated")).length === 0);
					}
				})
			}),
			/* @__PURE__ */ b("div", {
				className: "absolute bottom-6 left-1/2 transform -translate-x-1/2",
				children: /* @__PURE__ */ b(S, {
					intent: "success",
					onClick: () => {
						let t;
						try {
							t = h ? JSON.parse(h) : void 0;
						} catch {
							d({
								intent: "error",
								message: u("configEditor.json.invalid", "The JSON is not valid")
							});
							return;
						}
						if (t) {
							if ((e(t) || []).length > 0) {
								d({
									intent: "error",
									message: u("configEditor.json.invalid", "The JSON is not valid")
								});
								return;
							}
							h && f && (o(t), n());
						}
					},
					disabled: c,
					children: u("configEditor.actions.applyChanges", "Apply changes")
				})
			})
		]
	});
}, W = () => {
	let { t: e } = r(), { externalSchemas: t } = n(), i = A(U), { getValues: a, reset: o, trigger: s } = _(), { disabled: c } = v(), l = (e) => {
		let t = e;
		e.edgeCloudBusSettings && e.collectorSettings?.global && (t = {
			...e,
			collectorSettings: {
				...e.collectorSettings,
				global: {
					...e.collectorSettings.global,
					mqttEndpoint: e.edgeCloudBusSettings.mqttEndpoint
				}
			}
		}), o(t, { keepDefaultValues: !0 }), s();
	};
	return /* @__PURE__ */ b(w, {
		iconName: F,
		size: "md",
		intent: "default",
		onClick: () => {
			i.open({
				defaultValue: a(),
				onApply: l,
				onClose: () => i.close(),
				externalSchemas: t,
				disabled: c
			});
		},
		"aria-label": e("configEditor.actions.viewCode", "View code")
	});
}, G = ({ configId: e, isFormDisabled: t }) => {
	let { t: i } = r(), a = A(o), { onDelete: s, onShowLinkedGateways: c } = n(), l = async () => {
		e && s && await s(e);
	}, u = [{
		id: "show-linked-edge-gateways",
		label: i("configEditor.actions.showLinkedGateways", "Show linked edge gateways"),
		intent: "default",
		hidden: !c,
		startIcon: /* @__PURE__ */ b(C, { icon: L }),
		onClick: async () => {
			c && await c();
		}
	}, {
		id: "delete-configuration",
		label: i("configEditor.actions.deleteConfiguration", "Delete configuration"),
		intent: "danger",
		hidden: t || !s,
		startIcon: /* @__PURE__ */ b(C, { icon: B }),
		onClick: () => {
			a.open({
				message: i("configEditor.confirmation.deleteConfiguration", "Are you sure you want to delete this configuration?"),
				title: i("configEditor.actions.deleteConfiguration.title", "Delete Configuration"),
				onDelete: l
			});
		}
	}];
	return u.every((e) => e.hidden) ? null : /* @__PURE__ */ b(T, {
		items: u,
		allowedPlacements: ["bottom"],
		children: /* @__PURE__ */ b(w, {
			iconName: I,
			size: "md",
			intent: "default",
			"aria-label": i("configEditor.actions.moreOptions", "More options")
		})
	});
}, K = ({ configurationId: e }) => {
	let { t } = r(), { isDirty: i } = v(), { openToast: a } = j(), { onPush: o, metadata: s } = n(), [c, l] = g(!1), u = async () => {
		if (o) {
			l(!0);
			try {
				await o(e), a({
					message: t("configEditor.actions.pushConfiguration.success", "Configuration pushed successfully"),
					intent: "success"
				});
			} catch {
				a({
					message: t("configEditor.actions.pushConfiguration.failure", "Failed to push configuration"),
					intent: "error"
				});
			} finally {
				l(!1);
			}
		}
	}, d = () => i ? t("configEditor.actions.pushConfiguration.pleaseSave", "Please save your changes before pushing the configuration.") : s?.isPushDisabled ? t("configEditor.actions.pushConfiguration.upToDate", "All edge gateways are up to date.") : t("configEditor.actions.pushConfiguration.tooltip", "Push configuration to linked devices"), f = !e || i || c || !o || !!s?.isPushDisabled;
	return /* @__PURE__ */ b(D, {
		tooltip: d(),
		children: /* @__PURE__ */ b(w, {
			size: "md",
			customIcon: /* @__PURE__ */ b(C, {
				icon: c ? z : V,
				spin: c
			}),
			onClick: u,
			"aria-label": t("configEditor.actions.pushConfiguration.tooltip", "Push configuration to linked devices"),
			disabled: f
		})
	});
};
//#endregion
//#region src/components/Dialog/Dialog.tsx
function q({ title: e, children: t, classNames: n, confirmText: i, icon: a, onConfirm: o, onClose: s, onSave: c, isOpen: l = !0 }) {
	let { t: u } = r(), d = h(null);
	p(() => {
		l && d.current && !d.current.open ? d.current.showModal() : !l && d.current?.open && d.current.close();
	}, [l]);
	let f = () => {
		s?.();
	};
	return /* @__PURE__ */ x("dialog", {
		ref: d,
		className: k("flex flex-col relative p-8 bg-white rounded m-auto w-[385px] backdrop:bg-black/50 backdrop:backdrop-blur-sm", n?.modal),
		onClick: (e) => {
			e.target === e.currentTarget && f();
		},
		onClose: f,
		onCancel: f,
		children: [
			/* @__PURE__ */ x("div", {
				className: k("font-bold text-xl mb-2 flex flex-col gap-4 items-center", n?.header),
				children: [a, e]
			}),
			s && /* @__PURE__ */ b("button", {
				type: "button",
				className: "absolute top-5 right-5 cursor-pointer",
				onClick: f,
				"aria-label": u("configEditor.actions.close", "Close"),
				children: /* @__PURE__ */ b(C, {
					icon: P,
					fontSize: 28
				})
			}),
			/* @__PURE__ */ b("div", {
				className: "text-base flex-1",
				children: t
			}),
			(o || c) && /* @__PURE__ */ x("div", {
				className: "flex justify-center gap-2 mt-6",
				children: [o && /* @__PURE__ */ b(S, {
					variant: "outline",
					onClick: o,
					children: i ?? u("configEditor.actions.confirm", "Confirm")
				}), c && /* @__PURE__ */ b(S, {
					intent: "success",
					onClick: c,
					startIcon: /* @__PURE__ */ b(C, {
						icon: R,
						fontSize: 20
					}),
					children: u("configEditor.actions.save", "Save")
				})]
			})
		]
	});
}
//#endregion
//#region src/components/Block/Block.tsx
function J({ shouldBlock: e, title: t, message: n, confirmText: r, icon: i, onSave: a, onDiscard: o = H }) {
	let [s, c] = g(!1), u = async (e, t) => {
		a && (await a() === !1 ? t() : e(), c(!1));
	};
	return /* @__PURE__ */ b(l, {
		withResolver: !0,
		shouldBlockFn: typeof e == "function" ? e : () => e,
		enableBeforeUnload: () => typeof e == "function" ? !!e({
			action: "REPLACE",
			current: {
				fullPath: "/",
				pathname: window.location.pathname,
				params: {},
				routeId: "/",
				search: {}
			},
			next: {
				fullPath: "/",
				pathname: "/",
				params: {},
				routeId: "/",
				search: {}
			}
		}) : e,
		children: ({ status: e, proceed: a, reset: l }) => {
			if (!(e !== "blocked" || s)) return /* @__PURE__ */ b(Y, {
				title: t,
				message: n,
				icon: i,
				confirmText: r,
				onContinue: () => {
					a(), c(!1), o();
				},
				onClose: () => {
					l(), c(!1);
				},
				onSave: () => u(a, l)
			});
		}
	});
}
function Y({ title: e, message: t, confirmText: n, icon: r, onContinue: i, onClose: a, onSave: o }) {
	return /* @__PURE__ */ b(q, {
		title: e,
		icon: r,
		onConfirm: i,
		onClose: a,
		onSave: o,
		confirmText: n,
		children: t
	});
}
//#endregion
//#region src/components/Block/UnsavedChanges/index.tsx
function X({ shouldBlock: e, isDirty: t = !1, onSave: n, onDiscard: i }) {
	let { t: a } = r();
	return /* @__PURE__ */ b(J, {
		title: a("configEditor.block.reviewChanges", "Review changes"),
		icon: /* @__PURE__ */ b(C, {
			icon: R,
			size: "lg",
			className: "text-grey-400"
		}),
		message: /* @__PURE__ */ b(O, {
			className: "text-center text-grey-600",
			variant: "small-p",
			children: a("configEditor.block.unsavedChanges", "You have unsaved changes. Do you want to save or discard them?")
		}),
		confirmText: a("configEditor.actions.discardChanges", "Discard changes"),
		shouldBlock: e || t,
		onSave: n,
		onDiscard: i
	});
}
//#endregion
//#region src/components/layout/ConfigurationActionSaveButton.tsx
function Z(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Q(e) {
	let t = e.split("/").filter(Boolean);
	if (t.length === 0) return null;
	let n = t.map((e) => e.startsWith("$") ? "[^/]+" : Z(e)).join("/");
	return RegExp(`^/${n}(?:/|$)`);
}
var $ = ({ onSuccess: e, onError: t }) => {
	let { t: i } = r(), { handleSubmit: a, reset: o } = _(), { openToast: l } = j(), { isDirty: u, isSubmitting: d } = v(), { onSave: f, routeBasePath: p } = n(), m = async () => new Promise((n) => {
		a(async (r) => {
			try {
				let t = await f?.(r);
				l({
					message: i("configEditor.actions.saveConfiguration.success", "Configuration saved successfully"),
					intent: "success"
				}), o(t ?? r), e?.(), n(!0);
			} catch {
				l({
					message: i("configEditor.actions.saveConfiguration.failure", "Failed to save configuration"),
					intent: "error"
				}), t?.(), n(!1);
			}
		}, (e) => {
			c(e).forEach((e) => {
				l({
					message: s(e),
					intent: "error"
				});
			}), t?.(), n(!1);
		})();
	});
	return /* @__PURE__ */ x(y, { children: [/* @__PURE__ */ b(X, {
		shouldBlock: ({ next: e }) => d || Q(p)?.test(e.pathname) ? !1 : u,
		onSave: m
	}), /* @__PURE__ */ b(w, {
		intent: "fullgreen",
		customIcon: /* @__PURE__ */ b(C, {
			icon: d ? z : R,
			spin: d,
			fontSize: 16
		}),
		size: "md",
		disabled: !u || d,
		onClick: m,
		"aria-label": i("configEditor.actions.saveConfiguration", "Save configuration")
	})] });
}, ee = ({ fallbackHref: e, disabled: t, ...n }) => {
	let r = d(), i = m(() => !!r.history.location.state?.key, [r.history.location.state]);
	return /* @__PURE__ */ b(u, {
		to: e,
		onClick: f((e) => {
			if (t) {
				e.preventDefault();
				return;
			}
			i && r.history.canGoBack() && (e.preventDefault(), r.history.back());
		}, [
			t,
			i,
			r.history
		]),
		children: /* @__PURE__ */ b(w, {
			intent: "edit",
			iconName: M,
			size: "md",
			disabled: t,
			...n
		})
	});
};
//#endregion
//#region src/utils/routes.ts
function te(e) {
	return /\/collector\/connections\/[^/]+\/.+/.test(e);
}
//#endregion
export { G as a, K as i, ee as n, W as o, $ as r, U as s, te as t };

//# sourceMappingURL=routes-AG-jpSs5.js.map